module.exports = __webpack_public_path__ + "img/vca_logo_plain.f5900241.png";